import React from 'react';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
//import  "tabulator-tables/dist/css/tabulator_semanticui.css";
//import  "tabulator-tables/dist/css/tabulator_bootstrap5.css";
//import  "tabulator-tables/dist/css/tabulator_bootstrap4.css";
//import  "tabulator-tables/dist/css/tabulator_midnight.css";
//import  "tabulator-tables/dist/css/tabulator_modern.css";
//import  "tabulator-tables/dist/css/tabulator_site.css";
//import  "tabulator-tables/dist/css/tabulator_materialize.css";
//import  "tabulator-tables/dist/css/tabulator_bootstrap3.css";
import  "tabulator-tables/dist/css/tabulator.css";

import './TabulatorSoftdata.css';

class TabulatorSoftdata extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: props.rowData,
            columnDefs: props.columnDefs,
            columns: props.columns,
            height: 0,
            tabulator: null,            
        };
        this.initializeState = this.initializeState.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);      
        this.formatRow = this.formatRow.bind(this);
    }

    componentDidUpdate = async (prevProps) => {        
        if (this.props.rowData !== prevProps.rowData) {                     
            this.initializeState();
        }        
    }

    componentDidMount = async () => {        
        this.initializeState();
    }

    componentWillUnmount() {
        if (this.state.tabulator) {
            this.state.tabulator.destroy();
        }
    }

    formatRow(row)
    {
        var element = row.getElement();
        // If element contains a keyword, change css style
        if (element.textContent.includes("Base")){
            element.css({"font-weight":"bold"});
        }    
    }

    initializeState(){
        
        var layout = "fitColumns";

        var rowFormatter = (row) => {
            if ( (row.getData().id === 'base')
                || (row.getData().id === 'media')
                || (row.getData().id === 'nps')) {
              row.getElement().style.fontWeight = 'bold';
            }
            return row;
        };

        var tabulatorOptions = {         
            columnHeaderVertAlign: "middle",    
            layout: layout,
            columns: this.state.columnDefs,
            data: this.state.rowData,               
            frozenRowsField: "lineName",           
            rowFormatter: rowFormatter,
            // 1. DESLIGAR O WORD WRAP QUE CAUSA RECALCÚLOS CONSTANTES
            headerWordWrap: false, 
            // 2. O CORTA-CORRENTE: Desliga o Virtual DOM que está a causar o loop infinito!
            renderVertical: "basic", 
        }

        // 3. MATAR A TABELA FANTASMA: Se já existia uma tabela, destrói-a antes de criar a nova
        if (this.state.tabulator) {
            this.state.tabulator.destroy();
        }

        var tabulatorInstance=new Tabulator('#tabulator',tabulatorOptions);
        
        this.setState({tabulator: tabulatorInstance});
        this.setState({displayTable: true});
        
    }

    render() {
        return (
            
            <div style={{width: "100%"}} id="tabulator"></div>
        );
    }
};
export default TabulatorSoftdata;